module.exports = __webpack_public_path__ + "static/media/passion.5f745354.jp2";